<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="所属厂区">
              <a-select v-model.trim="queryParam.factoryId" default-value="0" placeholder="请选择">
                <a-select-option value>全选</a-select-option>
                <a-select-option
                  v-for="(item, index) in factorySelect"
                  :key="index"
                  :value="item.id"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="门禁号">
              <a-input v-model.trim="queryParam.code" placeholder="请输入" />
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-button
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x:500 }"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handleDel(record)">删除</a>
      </span>
    </s-table>

    <a-modal
      title="编辑"
      style="top: 20px;"
      :width="560"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">
        <a-form-item label="门禁编号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.code"
            placeholder="请输入门禁编号"
            v-decorator="['code',
            { initialValue: mdl.code, rules: [{ required: true, message: '请输入门禁编号'}]}]"
          />
        </a-form-item>

        <a-form-item label="门禁说明" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.description"
            placeholder="请输入门禁说明"
            v-decorator="['description',
            { initialValue: mdl.description, rules: [{ required: true, message: '请输入门禁说明'}]}]"
          />
        </a-form-item>

        <a-form-item label="所属厂区" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            v-model="mdl.factoryId"
            placeholder="请选择所属厂区"
            v-decorator="['factoryId',
            { initialValue: mdl.factoryId, rules: [{ required: true, message: '请选择所属厂区'}]}]"
          >
            <a-select-option
              v-for="(item, index) in factorySelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { factoryDoorPage, factoryList, factoryDoorUpdate, factoryDoorSave, factoryDoorDelete } from '../../api/basic'
import storage from '@/utils/storage'
import { formatDate } from '@/utils/date'
export default {
  name: 'Factory',
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
           width: '40px',
           fixed:"left"
        },
        {
          title: '门禁编号',
          dataIndex: 'code',
          width: '150px',
        },
        {
          title: '门禁说明',
          dataIndex: 'description',
          width: '150px',
        },
        {
          title: '所属厂区',
          dataIndex: 'factoryName',
          width: '150px',
        },
        {
          title: '创建人',
          dataIndex: 'createId',
          width: '150px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
         {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
         {
          title: '更新人',
          dataIndex: 'updateId',
          width: '140px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '操作',
          width: '170px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed:"right"
        }
      ],

      // 所属菜单下拉
      factorySelect: null,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return factoryDoorPage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    this.loadSelect()
  },
  methods: {
    loadSelect() {
      // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = factoryList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.factorySelect = res
      })
    },
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit(record) {
      this.mdl = Object.assign({}, record)
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleAdd() {
      this.mdl = {}
      this.mdl.factoryId = this.queryParam.factoryId
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          if (this.mdl.id !== undefined) {
            factoryDoorUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            factoryDoorSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          return factoryDoorDelete({ ids: record.id })
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {})
        },
        onCancel() {}
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  }
}
</script>
